import React from 'react';

function Footer() {
  return (
    <footer style={{ padding: '20px', backgroundColor: 'black', color: 'white', textAlign: 'center' }}>
      <p>© 2024 Haute-U-AR, All rights reserved.</p>
      <p>Follow us on social media</p>
      <div>
        {/* Add social media links here */}
      </div>
    </footer>
  );
}

export default Footer;
